<mat-toolbar-row class="bg-zinc-50" fxLayoutAlign="space-between center">
    <h2 matDialogTitle class="text-[22px] font-medium text-gray-700 text-truncate leading-[28px]">{{ title | translate: titleParams }} {{ additionalText | translate }}</h2>
    <span class="example-spacer"></span>
    <mat-icon class="close-dialog pointer" (click)="onClickButton($event)">{{ closeIcon }}</mat-icon>
</mat-toolbar-row>
